import { Environment, Lightformer } from "@react-three/drei";

export default function Lights(props) {
  return (
    <>
      <ambientLight />
      <directionalLight
        castShadow
        intensity={1}
        position={[10, 6, 6]}
        shadow-mapSize={[1024, 1024]}
      >
        <orthographicCamera
          attach="shadow-camera"
          left={-20}
          right={20}
          top={20}
          bottom={-20}
        />
      </directionalLight>
      <Environment resolution={512}>
        {/* Ceiling */}
        <Lightformer
          form="ring"
          intensity={1}
          rotation-x={Math.PI / 2}
          position={[0, 4, -6]}
          scale={[10, 1, 1]}
        />
        <Lightformer
          intensity={1}
          rotation-x={Math.PI / 2}
          position={[0, 4, -3]}
          scale={[10, 1, 1]}
        />
        <Lightformer
          intensity={1}
          rotation-x={Math.PI / 2}
          position={[0, 4, 0]}
          scale={[10, 1, 1]}
        />
        <Lightformer
          intensity={1}
          rotation-x={Math.PI / 2}
          position={[0, 4, 3]}
          scale={[10, 1, 1]}
        />
        <Lightformer
          intensity={1}
          rotation-x={Math.PI / 2}
          position={[0, 4, 6]}
          scale={[10, 1, 1]}
        />
        <Lightformer
          intensity={1}
          rotation-x={Math.PI / 2}
          position={[0, 4, 9]}
          scale={[10, 1, 1]}
        />
        {/* backdrop */}
        <Lightformer
          intensity={1}
          scale={[30, 15, 1]}
          position={[0, 1, -9]}
          rotation-x={Math.PI / 2}
        />
      </Environment>
    </>
  );
}
